<modal-popup
  [flexible]="true"
  [focusOnOpen]="false"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.cat.createCat'"
>
  <div class="container">
    
    <!-- Library type (Product / Master) -->
    <input-wrap
      cssClass="l-cell-spread library-type"
    >
      <p-selectButton
        [options]="libraryTypeOptions"
        [(ngModel)]="isMaster"
        optionLabel="label"
        optionValue="value"
        class="l-cell-spread-x"
        (onChange)="onIsMasterChange($event)"
        [disabled]="masterLibraryExists"
      >
        <ng-template let-item pTemplate="item">
          <span>{{ item.label | translate }}</span>
        </ng-template>
      </p-selectButton>
    </input-wrap>

    <!--cat name-->
    <input-wrap
      label="{{ 'translate.general.catDescr' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
    >
      <input type="text" [(ngModel)]="catDescr" class="t-input" />
    </input-wrap>

    <!--product-->
    <input-wrap
      *ngIf="!isMaster"
      [loading]="productList && productList.loading"
      label="{{ 'translate.general.productDescr' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
    >
      <p-select
        [options]="productList"
        optionLabel="label"
        [(ngModel)]="product"
        class="l-cell-spread-x"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.select' | translate"
        [filter]="true"
        appendTo="body"
        baseZIndex="100"
      >
      </p-select>
    </input-wrap>

    <!--claims management type-->
    <input-wrap
      *ngIf="isMaster"
      label="{{ 'translate.general.claimsManagementType' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
    >
      <p-select
        [options]="claimsManagementTypesList"
        optionLabel="label"
        [(ngModel)]="claimsManagementType"
        [disabled]="isMaster && useOldVersion"
        class="l-cell-spread-x"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.select' | translate"
        [filter]="true"
        appendTo="body"
        baseZIndex="100"
      >
      </p-select>
    </input-wrap>

    <input-wrap
      [loading]="refMatchTypeList && refMatchTypeList.loading"
      label="{{ 'translate.general.refMatchType' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
    >
      <p-select
        [options]="refMatchTypeList"
        optionLabel="label"
        [(ngModel)]="refMatchType"
        class="l-cell-spread-x"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.select' | translate"
        [filter]="true"
        appendTo="body"
        baseZIndex="100"
      >
      </p-select>
    </input-wrap>

    <checkbox-wrap 
    class="checkbox use-old-version-checkbox" 
    label="{{'translate.general.useOldVersion' | translate }}"
    [labelStyle]="{ 'font-size': '0.7rem','margin-top': '3px' }"
    >
      <input type="checkbox" [(ngModel)]="useOldVersion" (change)="onUseOldVersionChange()" />
    </checkbox-wrap>
    
    <div *ngIf="useOldVersion" class="c-warn use-old-version-warning">
       {{ 'translate.cat.legacyLibraryWarning' | translate }}
    </div>

    <!--type-->
    <input-wrap
      *ngIf="useOldVersion && !extSw"
      [loading]="typeList && typeList.loading"
      label="{{ 'translate.general.typeDescr' | translate }}"
      [required]="useOldVersion"
      cssClass="l-cell-spread"
    >
      <p-select
        [options]="typeList"
        optionLabel="label"
        [(ngModel)]="type"
        class="l-cell-spread-x"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.select' | translate"
        [filter]="true"
        appendTo="body"
        baseZIndex="100"
      >
      </p-select>
    </input-wrap>

    <input-wrap
       *ngIf="useOldVersion"
       [loading]="langList && langList.loading"
       label="{{ 'translate.general.langDescr' | translate }}"
       [required]="useOldVersion"
       cssClass="l-cell-spread"
     >
       <p-select
         [options]="langList"
         optionLabel="label"
         [(ngModel)]="lang"
         class="l-cell-spread-x"
         [resetFilterOnHide]="true"
         [filterPlaceholder]="'translate.general.search' | translate"
         [placeholder]="'translate.general.select' | translate"
         [filter]="true"
         appendTo="body"
         baseZIndex="100"
       >
       </p-select>
     </input-wrap>

    <div class="actions">
      <button class="t-button-outline" (click)="close()">
        {{ "translate.general.cancel" | translate }}
      </button>
      &nbsp;
      <button class="t-button" [disabled]="!enableSubmit" (click)="save()">
        {{ "translate.general.ok" | translate }}
      </button>
    </div>
  </div>

  <loader *ngIf="saving"></loader>
</modal-popup>
